/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BicycleChangingType {
    SHOWER = 'SHOWER',
    CHANGING_ROOM = 'CHANGING_ROOM',
    LOCKER = 'LOCKER',
}
